import { ref } from "vue";
import api from "@/modules/api";

const RESEND_INTERVAL_MS = 60;
export default () => {
  const email = ref("");
  const verifyCode = ref("");
  const nextResendTime = ref(0);

  const sendVerificationCode = async () => {
    await api.createOneVerification({ email: email.value });
    nextResendTime.value = Date.now() + RESEND_INTERVAL_MS * 1000;
  };

  return {
    email,
    verifyCode,
    nextResendTime,
    sendVerificationCode,
  };
};
